import { Api } from "@/services/Api";
import store from "../store";

export default {
  citySearch(data) {
    var token = process.env.VUE_APP_MAPBOX_TOKEN;
    return Api().get(
      "https://api.mapbox.com/geocoding/v5/mapbox.places/" +
        data.query +
        ".json?limit=10&types=place%2Cdistrict%2Ccountry%2Clocality&access_token=" +
        token
    );
  },
  listAmenities() {
    return Api().get("listing/amenities-list");
  },
  propertyAdd(data) {
    var token = store.state.token;
    const headers = {
      Authorization: "Bearer " + token
    };
    return Api().post("listing/add", data, {
      headers
    });
  },
  propertyUpdate(data) {
    var token = store.state.token;
    const headers = {
      Authorization: "Bearer " + token
    };
    return Api().post("listing/update", data, {
      headers
    });
  },
  updateMapLocation(data) {
    var token = store.state.token;
    const headers = {
      Authorization: "Bearer " + token
    };
    return Api().post("listing/update_map_location", data, {
      headers
    });
  },
  addYoutubeUrl(data) {
    var token = store.state.token;
    const headers = {
      Authorization: "Bearer " + token
    };
    return Api().post("listing/add_youtube_url", data, {
      headers
    });
  },
  removeYoutubeUrl(data) {
    var token = store.state.token;
    const headers = {
      Authorization: "Bearer " + token
    };
    return Api().post("listing/remove_youtube_url", data, {
      headers
    });
  },
  getImages(data) {
    var token = store.state.token;
    const headers = {
      Authorization: "Bearer " + token
    };
    return Api().post("listing/images", data, {
      headers
    });
  },
  uploadImage(formData) {
    var token = store.state.token;
    const headers = {
      Authorization: "Bearer " + token
    };
    return Api().post("listing/upload_picture", formData, {
      headers
    });
  },
  imageOrder(data) {
    var token = store.state.token;
    const headers = {
      Authorization: "Bearer " + token
    };
    return Api().post("listing/images/order", data, {
      headers
    });
  },
  imageCaption(data) {
    var token = store.state.token;
    const headers = {
      Authorization: "Bearer " + token
    };
    return Api().post("listing/images/caption", data, {
      headers
    });
  },
  imageDelete(data) {
    var token = store.state.token;
    const headers = {
      Authorization: "Bearer " + token
    };
    return Api().post("listing/images/delete", data, {
      headers
    });
  },
  getVideos(data) {
    var token = store.state.token;
    const headers = {
      Authorization: "Bearer " + token
    };
    return Api().post("listing/videos", data, {
      headers
    });
  },
  uploadVideo(formData) {
    var token = store.state.token;
    const headers = {
      Authorization: "Bearer " + token
    };
    return Api().post("listing/upload_video", formData, {
      headers
    });
  },
  videoDelete(data) {
    var token = store.state.token;
    const headers = {
      Authorization: "Bearer " + token
    };
    return Api().post("listing/video/delete", data, {
      headers
    });
  },
  addReview(data) {
    var token = store.state.token;
    const headers = {
      Authorization: "Bearer " + token
    };
    return Api().post("user/add/property_review", data, {
      headers
    });
  },
  getReviews() {
    var token = store.state.token;
    const headers = {
      Authorization: "Bearer " + token
    };
    return Api().get("user/get/reviews", {
      headers
    });
  },
  listProperties() {
    var token = store.state.token;
    const headers = {
      Authorization: "Bearer " + token
    };
    return Api().get("listing/list", {
      headers
    });
  },
  guestViewProperty(data) {
    var token = store.state.token;
    const headers = {
      Authorization: "Bearer " + token
    };
    return Api().post("listing/guest_view", data, {
      headers
    });
  },
  guestViewNPProperty(data) {
    var token = store.state.token;
    const headers = {
      Authorization: "Bearer " + token
    };
    return Api().post("listing/guest_np_view", data, {
      headers
    });
  },
  contactOwner(data) {
    return Api().post("listing/request_owner_contact", data);
  },
  viewProperty(data) {
    var token = store.state.token;
    const headers = {
      Authorization: "Bearer " + token
    };
    return Api().post("listing/view", data, {
      headers
    });
  },
  editViewProperty(data) {
    var token = store.state.token;
    const headers = {
      Authorization: "Bearer " + token
    };
    return Api().post("listing/edit-view", data, {
      headers
    });
  },
  archiveListing(data) {
    var token = store.state.token;
    const headers = {
      Authorization: "Bearer " + token
    };
    return Api().post("listing/archive", data, {
      headers
    });
  },
  searchListings(data) {
    return Api().post("listing/search", data);
  },
  searchLocation(data) {
    return Api().post("listing/search-location", data);
  }
};
